module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inp-modal modal fade noselect",
    attrs: {
      "id": "modalPropositionsEntreeSalarie"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-xl"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('form', {
    staticClass: "form detail-height"
  }, [_c('div', {
    staticClass: "row ml-1 mb-1"
  }, [_c('div', {
    staticClass: "title-head mr-2"
  }, [_vm._v("Salariés déjà existants")]), _vm._v(" "), _c('button', {
    staticClass: "inp-button green mr-3",
    attrs: {
      "type": "button",
      "data-testid": "entryRequest-add-newEmployee-button"
    },
    on: {
      "click": function($event) {
        _vm.valider()
      }
    }
  }, [_c('span', {
    staticClass: "fas fa-plus"
  }), _vm._v(" "), _c('span', {
    staticClass: "text ml-1 d-none d-xl-inline"
  }, [_vm._v("Nouveau salarié")])]), _vm._v(" "), _c('div', {
    staticClass: "inp-input-mini icon mr-3 ml-auto"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterName),
      expression: "filterName"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "maxlength": "50",
      "placeholder": "Rechercher"
    },
    domProps: {
      "value": (_vm.filterName)
    },
    on: {
      "keyup": function($event) {
        _vm.doFilter()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filterName = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.filterName.length == 0) ? _c('span', {
    staticClass: "icon-inner fas fa-search"
  }) : _c('span', {
    staticClass: "icon-inner fas fa-times cls",
    on: {
      "click": function($event) {
        _vm.filterName = '';
        _vm.doFilter()
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row m-0"
  }, [_c('div', {
    staticClass: "inp-table noselect table"
  }, [_c('div', {
    staticClass: "thead"
  }, [_c('div', {
    staticClass: "tr"
  }, [_c('div', {
    staticClass: "th cln-numero",
    attrs: {
      "title": "N° Salarié"
    },
    on: {
      "click": function($event) {
        _vm.orderBy('NumeroSalarie')
      }
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("N° Salarié")]), _vm._v(" "), _c('span', {
    staticClass: "arrow"
  }, [_c('span', {
    class: 'icons fas fa-chevron-circle-up ' + _vm.getClassOfOrder('NumeroSalarie', false)
  }), _vm._v(" "), _c('span', {
    class: 'icons fas fa-chevron-circle-down ' + _vm.getClassOfOrder('NumeroSalarie', true)
  })])]), _vm._v(" "), _c('div', {
    staticClass: "th cln-civilite",
    attrs: {
      "title": "Civilité"
    },
    on: {
      "click": function($event) {
        _vm.orderBy('Civilite')
      }
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("Civilité")]), _vm._v(" "), _c('span', {
    staticClass: "arrow"
  }, [_c('span', {
    class: 'icons fas fa-chevron-circle-up ' + _vm.getClassOfOrder('Civilite', false)
  }), _vm._v(" "), _c('span', {
    class: 'icons fas fa-chevron-circle-down ' + _vm.getClassOfOrder('Civilite', true)
  })])]), _vm._v(" "), _c('div', {
    staticClass: "th cln-nom-prenom",
    attrs: {
      "title": "Nom / Prénom"
    },
    on: {
      "click": function($event) {
        _vm.orderBy('NomPrenom')
      }
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("Nom / Prénom")]), _vm._v(" "), _c('span', {
    staticClass: "arrow"
  }, [_c('span', {
    class: 'icons fas fa-chevron-circle-up ' + _vm.getClassOfOrder('NomPrenom', false)
  }), _vm._v(" "), _c('span', {
    class: 'icons fas fa-chevron-circle-down ' + _vm.getClassOfOrder('NomPrenom', true)
  })])]), _vm._v(" "), _c('div', {
    staticClass: "th cln-nom-naissance",
    attrs: {
      "title": "Nom de naissance"
    },
    on: {
      "click": function($event) {
        _vm.orderBy('NomNaissance')
      }
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("Nom de naissance")]), _vm._v(" "), _c('span', {
    staticClass: "arrow"
  }, [_c('span', {
    class: 'icons fas fa-chevron-circle-up ' + _vm.getClassOfOrder('NomNaissance', false)
  }), _vm._v(" "), _c('span', {
    class: 'icons fas fa-chevron-circle-down ' + _vm.getClassOfOrder('NomNaissance', true)
  })])]), _vm._v(" "), _vm._m(1)])]), _vm._v(" "), _c('div', {
    staticClass: "tbody"
  }, [_vm._m(2), _vm._v(" "), _vm._l((_vm.listeSalariesFiltres), function(salarie) {
    return _c('div', {
      staticClass: "tr"
    }, [_c('div', {
      staticClass: "td cln-numero text-right",
      attrs: {
        "title": salarie.Numero
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(salarie.NumeroSalarie) + "\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
      staticClass: "td cln-civilite",
      attrs: {
        "title": salarie.Civilite
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(salarie.Civilite) + "\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
      staticClass: "td cln-nom-prenom",
      attrs: {
        "title": salarie.NomPrenom
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(salarie.NomPrenom) + "\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
      staticClass: "td cln-nom-naissance",
      attrs: {
        "title": salarie.NomNaissance
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(salarie.NomNaissance) + "\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
      staticClass: "td cln-action"
    }, [_c('button', {
      staticClass: "inp-button green mr-3",
      attrs: {
        "type": "button",
        "data-testid": _vm.getEmployeeEntryRequestButton(salarie, '')
      },
      on: {
        "click": function($event) {
          _vm.valider(salarie.IdSalarie)
        }
      }
    }, [_c('span', {
      staticClass: "fas fa-plus"
    }), _vm._v(" "), _c('span', {
      staticClass: "text ml-1 d-none d-xl-inline"
    }, [_vm._v("Récupérer")])])])])
  })], 2)]), _vm._v(" "), (!_vm.dataReady) ? _c('loader') : _vm._e()], 1)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("Demande d'entrée")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close",
      "title": "Fermer"
    }
  }, [_c('span', {
    staticClass: "fas fa-times"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "th cln-action",
    attrs: {
      "title": "Action"
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("Action")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "section cln-numero"
  }), _vm._v(" "), _c('div', {
    staticClass: "section cln-civilite"
  }), _vm._v(" "), _c('div', {
    staticClass: "section cln-nom-prenom"
  }), _vm._v(" "), _c('div', {
    staticClass: "section cln-nom-naissance"
  }), _vm._v(" "), _c('div', {
    staticClass: "section cln-action"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21459744"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/modalComponents/modalPropositionsEntreeSalarie/modalPropositionsEntreeSalarie.vue.html
// module id = oCjY
// module chunks = 2